import {
  GET_BARNERS,
  GET_BARNER,
  ADD_BARNER,
  UPDATE_BARNER,
  BARNERS_LOADING,
  BARNERS_ERROR
} from '../actions/types';

const initialState = {
  banners: [],
  currentBanner: null,
  loading: false,
  error: null
};

const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case BARNERS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case GET_BARNERS:
      return {
        ...state,
        banners: action.payload,
        loading: false,
        error: null
      };
    
    case GET_BARNER:
      return {
        ...state,
        currentBanner: action.payload,
        loading: false,
        error: null
      };
    
    case ADD_BARNER:
      return {
        ...state,
        banners: [action.payload.banner, ...state.banners],
        loading: false,
        error: null
      };
    
    case UPDATE_BARNER:
      return {
        ...state,
        banners: state.banners.map(banner => 
          banner._id === action.payload._id ? action.payload : banner
        ),
        currentBanner: state.currentBanner && state.currentBanner._id === action.payload._id 
          ? action.payload 
          : state.currentBanner,
        loading: false,
        error: null
      };
    
    case BARNERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default bannerReducer;
